import { stopSubmit } from "redux-form"
import { ResultResponseType, authFirebaseAPI } from "../../../services/firebase-api/firebase-auth";
import { PreloaderCodesEnum } from "../../../types/types"
import { ClientType, ManagerType, UserType } from "../../../types/user-types"
import { InferActionsTypes, ThunkType } from "../../store"
import { inProgress } from "../preloader/preloader-reducer"
import { onAuthStateChanged } from "firebase/auth";
import { getAndDispatchUser } from "../../../utils/auth/auth-util";
import { ResultCodesEnum } from "../../../services/api-laravel";
import { httpsCallable } from "firebase/functions";
import { clientAPI, functions } from "../../../services/firebase-api/firebase-api";

// import { authAPI } from "../../../services/api";

//TYPES
type AuthStateType = typeof initialState
type AuthThunkType = ThunkType<SetAuthUserDataType | ReturnType<typeof stopSubmit> | ReturnType<typeof inProgress>>
type SetAuthUserDataType = InferActionsTypes<typeof actions>


export type ClientMJStatusType = {
    isMj: boolean,
    isMedical: boolean,
    isRecreation: boolean,
}


//STATE
let initialState = {
    isAuth: false as boolean,
    authUser: null as UserType | null,
    isFetched: false as boolean,
    error: {
        message: '',
        status: false,
    },
    current: {
        user: null as UserType | null,
        role: null as 'client' | 'manager' | 'admin' | null,
        entity: null as ClientType | ManagerType | null
    }
}



//ACION CREATORS
const actions = {
    setAuthUserData: (authUser: UserType | null, isAuth: boolean = false) =>
        ({ type: 'SP/AUTH/SET_USER_DATA', authUser, isAuth } as const),
    setAuthError: (status: boolean, message?: string) =>
        ({ type: 'SP/AUTH/SET_AUTH_ERROR', status, message } as const)
}



//THUNKS

export const getAuthApp = (): AuthThunkType => async (dispatch) => {
    dispatch(inProgress(true, PreloaderCodesEnum.Global))
    let auth = await authFirebaseAPI.getAuth()
    let user = auth.currentUser


    if (user) {
     
        await getAndDispatchUser(user.uid, dispatch, actions.setAuthUserData)
    }





    onAuthStateChanged(auth, async (user) => {
        if (user) {
            await getAndDispatchUser(user.uid, dispatch, actions.setAuthUserData)
        } else {
            dispatch(actions.setAuthUserData(null, false))
        }
        dispatch(inProgress(false, PreloaderCodesEnum.Global))
    })

    dispatch(inProgress(false, PreloaderCodesEnum.Global))

}



export const login = (email: string, password: string): AuthThunkType => async (dispatch) => {
    dispatch(inProgress(true, PreloaderCodesEnum.Global))

    let currentUser = null
    try {

        currentUser = await authFirebaseAPI.signIn(email, password)

        if (currentUser) {
            dispatch(actions.setAuthUserData(currentUser, true))
        } else {
            dispatch(actions.setAuthUserData(null, false))
        }
        dispatch(inProgress(false, PreloaderCodesEnum.Global))
    } catch (e) {

        let message = 'Email or Password was wrong !'

        let action = stopSubmit('login', {
            _error: message
        })
        dispatch(action)
        dispatch(inProgress(false, PreloaderCodesEnum.Global))
    }





}
export const logout = (): AuthThunkType => async (dispatch) => {
    dispatch(inProgress(true, PreloaderCodesEnum.Global))
    await authFirebaseAPI.signOut()
    dispatch(actions.setAuthUserData(null, false))
    dispatch(inProgress(false, PreloaderCodesEnum.Global))
}

export const setNewUser = ( //registration
    name: string,
    surname: string,
    email: string,
    password: string,
    phone: string,
    documentType: string,
    documentNumber: string,
    birthday: any,
    clientStatus: ClientMJStatusType,
    documentPhoto: any,
    documentPhoto2: any,
    signature: any
) => async (dispatch: any) => {

    dispatch(inProgress(true, PreloaderCodesEnum.Component))


    // try {
    // let res = await authAPI.register(name, surname, email, password, password_confirmation)
    // @ts-ignore
    let response: ResultResponseType = await authFirebaseAPI.signUp(
        name,
        surname,
        email,
        password,
        phone,
        documentType,
        documentNumber,
        birthday,
        clientStatus,
        documentPhoto,
        documentPhoto2,
        signature
    )


    //@ts-ignore
    if (response.resultCode === ResultCodesEnum.Error) {
        console.log('user does\'t created')
        let message = response.message || 'invalid response !'

        // dispatch(actions.setAuthError(true, message))
        let action = stopSubmit('login', {
            _error: message
        })
        dispatch(action)
    } else if (response.resultCode === ResultCodesEnum.Success && response.data && response.data.user) {
        dispatch(actions.setAuthUserData(response.data.user, true))

    } else {
        let message = 'invalid response !'
        let action = stopSubmit('login', {
            _error: message
        })
        dispatch(action)
    }

    dispatch(inProgress(false, PreloaderCodesEnum.Component))
}




//REDUCER
const authReducer = (state: AuthStateType = initialState, action: SetAuthUserDataType): AuthStateType => {
    let result = state

    switch (action.type) {

        case "SP/AUTH/SET_USER_DATA":
            result = { ...state }
            result.isAuth = action.isAuth
            result.authUser = action.authUser//запоминаем аутентифицированного пользователя в state
            result.isFetched = true
            return result

        case 'SP/AUTH/SET_AUTH_ERROR':
            return action.status !== state.error.status ? {
                ...state, error: {
                    ...state.error,
                    message: action.message ? action.message : '',
                    status: action.status,
                }
            }
                : state

        default:
            return result
    }

}
export default authReducer